module.exports = __webpack_public_path__ + "static/media/challenge.0dd38b3d.svg";